import React from 'react';
import './style.css'; // Make sure the path to your CSS file is correct

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
